import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import FAQAccordion from "@/components/FAQAccordion";
import { useLang } from "@/context/LanguageContext";
import { useData } from "@/context/DataContext";
import { openWa } from "@/lib/wa";
import { MessageCircle } from "lucide-react";

export default function FaqPage() {
  const { t, pick } = useLang();
  const { faqs } = useData();

  return (
    <main>
      <SEO title="الأسئلة الشائعة | ميرو للإطارات وخدمات السيارات" description="أجوبة عن أكثر الأسئلة شيوعاً حول خدمات ميرو للإطارات المتنقلة في الرياض: طلب الخدمة، التغطية، التكلفة، حساسات الكفرات، والمقاسات." path="/faq" />
      <PageHero eyebrow="FAQ" title={t("faq.title")} sub={t("faq.sub")} />
      <section className="pb-24">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <FAQAccordion items={(faqs || []).map((f) => ({ q: pick(f.q_ar, f.q_en), a: pick(f.a_ar, f.a_en) }))} />
          <button onClick={() => openWa()} className="btn-wa mt-10 w-full" data-testid="faq-wa-cta"><MessageCircle size={18} /> {t("cta.askWa")}</button>
        </div>
      </section>
    </main>
  );
}
